export const LABELS = {
  configTabTitle: "My APMs",
  createNewAPMFile: "Create new APM File",
};
